/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainEntitiesAghanimPaymentStatus;
(function (FxIdDomainEntitiesAghanimPaymentStatus) {
    FxIdDomainEntitiesAghanimPaymentStatus[FxIdDomainEntitiesAghanimPaymentStatus["Created"] = 0] = "Created";
    FxIdDomainEntitiesAghanimPaymentStatus[FxIdDomainEntitiesAghanimPaymentStatus["Payed"] = 1] = "Payed";
    FxIdDomainEntitiesAghanimPaymentStatus[FxIdDomainEntitiesAghanimPaymentStatus["Cancelled"] = 2] = "Cancelled";
    FxIdDomainEntitiesAghanimPaymentStatus[FxIdDomainEntitiesAghanimPaymentStatus["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainEntitiesAghanimPaymentStatus || (FxIdDomainEntitiesAghanimPaymentStatus = {}));
export function instanceOfFxIdDomainEntitiesAghanimPaymentStatus(value) {
    for (const key in FxIdDomainEntitiesAghanimPaymentStatus) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainEntitiesAghanimPaymentStatus, key)) {
            if (FxIdDomainEntitiesAghanimPaymentStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainEntitiesAghanimPaymentStatusFromJSON(json) {
    return FxIdDomainEntitiesAghanimPaymentStatusFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesAghanimPaymentStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainEntitiesAghanimPaymentStatusToJSON(value) {
    return value;
}
export function FxIdDomainEntitiesAghanimPaymentStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainEntitiesAghanimPaymentStatus.js.map